const MembershipBillingFrequency = Object.freeze({
    PLAN_LENGTH: 'Plan Length',
    MONTHLY: 'Monthly',
});

module.exports = MembershipBillingFrequency;
